export const MANUAL_ENTRY_RECIPIENT_ID = "manualEntry";
export const ADD_GP_DISPLAY_TYPES = {
    SEARCH: "search",
    MANUAL: "manual",
};
